// @flow
import i18n from "i18next";
import k from "src/i18n/keys"; /* eslint-disable no-extra-boolean-cast */
// @flow

import React from "react";
import { connect } from "react-redux";

import { Stack, Radio, RadioGroup } from "@chakra-ui/react";
import { setNewChartDialogAttributes } from "src/actions/chart";

type Props = {
  value: ?boolean,
  _setNewChartDialogAttributes: Function,
};

const MultipleSelection = ({ value, _setNewChartDialogAttributes }: Props) => {
  const handleMultipleSelection = (value: string) => {
    _setNewChartDialogAttributes({
      relativeCount: value === "on",
    });
  };

  return (
    <RadioGroup
      onChange={handleMultipleSelection}
      value={`${!!value ? "on" : "off"}`}
    >
      <Stack>
        <Radio id="proportion" value="on" size="sm">
          {i18n.t(k.Y_AXIS_SHOWS_TOTAL_CONVERSATIO1)}
        </Radio>

        <Radio id="equalValue" value="off" size="sm">
          {i18n.t(k.Y_AXIS_SHOWS_TOTAL_VALUE_COUNT)}
        </Radio>
      </Stack>
    </RadioGroup>
  );
};

export default connect(null, {
  _setNewChartDialogAttributes: setNewChartDialogAttributes,
})(MultipleSelection);
